import React from 'react'

import Layout from '@/components/Layout'
import SEO from '@/components/Seo'

import { TheChileLatam } from '@/components/Rankings'
import { Content } from '@/components/Rankings/style.css'
import { Columns } from '@/components/Article/style.css'
import Summary from '@/components/Summary'

const IndexPage = () => (
  <Layout>
    <SEO
      title="Las mejores 28 chilenas en el THE Latam"
      keywords={[
        `La Tercera`,
        `Ranking THE`,
        `Universidades Chilenas en el extranjero`,
      ]}
    />
    <Content>
      <h1>
        Las mejores 28 chilenas en el <strong>THE Latam</strong>
      </h1>
      <Columns>
        <p>
          La metodología usada por THE Latin American University Rankings
          considera los mismos 13 indicadores empleados en el ranking mundial.
          Estos se agrupan en cinco áreas: docencia, investigación, citas,
          perspectiva internacional e ingresos de la industria. Lo que lo
          diferencia del ranking global son las ponderaciones que se le asignan
          a cada factor, ya que en la mirada latinoamericana se potencian el
          entorno del aprendizaje y la investigación. Eso es lo que explica por
          qué hay grandes fluctuaciones en las posiciones alcanzadas por las
          universidades chilenas en ambas clasificaciones. Así, respecto de las
          universidades incluidas, el ranking lo lidera la Católica, seguida por
          la Chile, la Católica de Valparaíso, de Santiago, Austral, Santa
          María, de los Andes, Autónoma, de Concepción y Diego Portales. Las
          fortalezas de la UC se encuentran por el indicador transferencia de
          conocimientos con la industria (99,4), la investigación (99,8) y la
          perpectiva internacional (93,1). Mientras que en citas, lidera la
          Autónoma (100) y en docencia, la Chile (78,5).
        </p>
      </Columns>
      <TheChileLatam />
    </Content>
    <Summary />
  </Layout>
)

export default IndexPage
